export default __webpack_public_path__ + "static/media/pavlaka_12_0-18l.25e1a756.jpg";